export default __webpack_public_path__ + "static/media/RobotoCondensed-Bold.2acad7bb.ttf";